

//! bura yapılacak
const agirlikBirimOptions = [
    {
        value: 1,
        text :"Ton"
    },
    {
        value: 2,
        text :"Kg"
    },
    {
        value: 3,
        text :"Basar Tonaj"
    },
]


export default agirlikBirimOptions